/**
 * @fileoverview POSTWS handler for the "/engagement/api/segment_cohorts/text_to_sql" endpoint
 *
 * Used to request a SQL query from ChatGPT
 */
import fetch from "@lib/fetch";

import { reactQueryPostWebsocketAdapter } from "../reactQueryFetcherAdapters";

import { engagementApiSegmentCohortsTextToSql } from "./constants";
import type {
  PostwsEngagementApiSegmentCohortsTextToSqlPayload,
  PostwsEngagementApiSegmentCohortsTextToSqlProps,
} from "./types";

import { isSegmentCohortsExecuteTextToSqlResult } from "./validators";

export const segmentCohortsTextToSql = reactQueryPostWebsocketAdapter(
  engagementApiSegmentCohortsTextToSql,
  async (
    signal,
    { jobToken, formType, rangeOption, ...props }: PostwsEngagementApiSegmentCohortsTextToSqlProps
  ): Promise<{}> => {
    const payload: PostwsEngagementApiSegmentCohortsTextToSqlPayload = {
      ...props,
      job_token: jobToken,
      type: formType,
      range_option: rangeOption,
    };

    return fetch("/engagement/api/segment_cohorts/text_to_sql", "POST", payload, { signal });
  },
  isSegmentCohortsExecuteTextToSqlResult
);
